<template>
    <gofix-card classContent="mb-0" fullContent :class="['mb-0', {'run-loading': this.is_download}]">
        <gofix-default-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @delete-items="deleteRunsheet"
            ref="gofixTableHistory">

            <template slot="gofix_table:order_number" slot-scope="data">
                
                <router-link class="color-000" :to="`/v2/orders/${data.item.order_id}`" v-if="data.item.order_number">
                    {{data.item.order_number}}
                </router-link>
            </template>
            <template slot="gofix_table:job_number" slot-scope="data">
                <router-link class="color-000" :to="`/v2/job-list/${data.item.job_id}`" v-if="data.item.job_number">
                    {{data.item.job_number}}
                </router-link>
            </template>
            <template slot="gofix_table:report" slot-scope="data">
                <template v-if="(data.item.job_status == 'Verified' || data.item.job_status == 'Completed') && 
                    (
                        data.item.frequency && (data.item.frequency == '1Y' || data.item.frequency == '5Y')
                    )">
                    <div class="download-file cursor-pointer" @click.stop="showModalReportJob(data.item)">
                      <svg width="13" height="13" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#0f7dfe"/>
                      </svg>
                      <span>{{ data.item.frequency == '1Y' ? 'Report For Annual' : 'Report For 5 Year' }}</span>
                    </div>
                </template>
            </template>
            <template slot="gofix_table:order_started_date" slot-scope="data">
                {{data.item.order_started_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:order_completed_date" slot-scope="data">
                {{data.item.order_completed_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:job_started_date" slot-scope="data">
                {{data.item.job_started_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:job_completed_date" slot-scope="data">
                {{data.item.job_completed_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
        </gofix-default-table>
        <!-- <div style="width: 800px; position: fixed; opacity: 0; z-index:-1;">
            <LineChart :item="jobList"/>
        </div> -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" dialog-class="modal-confirm-update" hide-footer hide-header :centered="true" v-model="modal.reportFomat.open">
            <div class="center px-4 pt-3 pb-4">
             <h4 class="mb-2">Please select report fomat</h4>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="reportJob('report_path')" :disabled="modal.reportFomat.loading.report_path">
                    <b-spinner v-if="modal.reportFomat.loading.report_path" small type="grow"></b-spinner>Original Format
                </b-button>
            </b-button-group>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="reportJobBCA('pre092022')" :disabled="modal.reportFomat.loading.bca_1">
                    <b-spinner v-if="modal.reportFomat.loading.bca_1" small type="grow"></b-spinner>BCA format
                </b-button>
            </b-button-group>
          <b-button-group class="btn-group">
            <b-button class="custom-btn" @click="reportJobBCA('092022')" :disabled="modal.reportFomat.loading.bca_2">
                    <b-spinner v-if="modal.reportFomat.loading.bca_2" small type="grow"></b-spinner>BCA Format (September Version)
                </b-button>
          </b-button-group>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.reportFomat.open = false">Cancel</b-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    const LineChart = () => import("@/views/job/chart.vue")
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    export default {
        name: "equipment-history",
        components: {
            LineChart
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['equipment_history']))
            return {
                tableConfig:{
                    name: 'client-contract-equipment-history',
                    controls:{
                        create: false,
                        delete: this.$checkRole(this.$accessModule.job_list, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                },
                tableItems:[],
                is_download: false,
                timer: {
                    report: null,
                    delete: null
                },
                jobList: null,
                modal: {
                    reportFomat:{
                        open:false,
                        data: {
                            job_id: null,
                            frequency: null,
                        },
                        loading: {
                            report_path: false,
                            bca_1: false,
                            bca_2: false
                        }
                    }
                },
            };
        },
        created() {},
        computed: {
            ...mapGetters({
                equipment: "EquipmentV2Controller/equipment"
            })
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.equipment_id = this.$route.params.equipment_id;
                await this.$store.dispatch("EquipmentV2Controller/getEquipmentHistories", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the equipment histories", "danger");
                        reject();
                    })
            },
            showModalReportJob(job) {
                this.modal.reportFomat.data.job_id = job.job_id;
                this.modal.reportFomat.data.frequency = job.frequency;
                this.modal.reportFomat.open = true;
                this.modal.reportFomat.loading = {
                    report_path: false,
                    bca_1: false,
                    bca_2: false
                };
            },
            reportJob(formatType = 'report_path') {
                this.modal.reportFomat.open = false
                if(this.modal.reportFomat.loading.report_path) return;
                this.modal.reportFomat.loading.report_path = true;

                let name_report = '';
                if(this.modal.reportFomat.data.frequency) {
                    if(this.modal.reportFomat.data.frequency == '1Y') {
                        name_report = 'Report For Annual ';
                    }

                    if(this.modal.reportFomat.data.frequency == '5Y') {
                        name_report = 'Report For 5 Year ';
                    }

                    if(this.equipment && this.equipment.tag_name) {
                        name_report += `${this.equipment.tag_name} `;
                    }

                    name_report += `${moment().format('DD-MMM-YYYY')}.pdf`;
                }

                let nameFile = name_report ? name_report : 'report.pdf';
                this.$store.dispatch("JobController/reportJob", {
                    id: [this.modal.reportFomat.data.job_id],
                    mutil_file: false,
                    format_type: formatType,
                })
                .then(response => {
                    this.modal.reportFomat.loading.report_path = false;
                    if(response.data.size === 0) {
                        this.$alertNotification("Blank report", "warning");
                        return;
                    }
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                }).catch(err => {
                    this.modal.reportFomat.loading.report_path = false;
                });
            },
            reportJobBCA(version = '092022'){
                this.modal.reportFomat.open = false
                if(this.modal.reportFomat.loading.bca_1 || this.modal.reportFomat.loading.bca_2) return;
                if(version === '092022') {
                    this.modal.reportFomat.loading.bca_2 = true;
                } else {
                    this.modal.reportFomat.loading.bca_1 = true;
                }

                let name_report = '';
                if(this.modal.reportFomat.data.frequency) {
                    if(this.modal.reportFomat.data.frequency == '1Y') {
                        name_report = 'Report For Annual ';
                    }

                    if(this.modal.reportFomat.data.frequency == '5Y') {
                        name_report = 'Report For 5 Year ';
                    }

                    if(this.equipment && this.equipment.tag_name) {
                        name_report += `${this.equipment.tag_name} `;
                    }

                    name_report += `${moment().format('DD-MMM-YYYY')}.pdf`;
                }

                let nameFile = name_report ? name_report : 'report.pdf';
                this.$store.dispatch("JobController/reportJobBCA", {
                    ids: [this.modal.reportFomat.data.job_id],
                    version: version,
                }).then(response => {
                    this.modal.reportFomat.loading.bca_1 = this.modal.reportFomat.loading.bca_2 = false;
                    if(response.data.size === 0) {
                        this.$alertNotification("Blank report", "warning");
                        return;
                    }
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();
                }).catch(err => {
                    this.modal.reportFomat.loading.bca_1 = this.modal.reportFomat.loading.bca_2 = false;
                });
            },
            async deleteRunsheet(callback){
                const { ids, filter, resolve, reject } = await callback();
                this.$store.dispatch("JobController/deleteRunsheet", { ids: ids })
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'job_list'))
                }).catch(err => {
                    reject(err);
                });
            }
        }
    }
</script>
